import { Injectable } from '@angular/core';

export type ServiceCard = {
  id: string;
  title: string;
  description: string;
  accent: string;
  url: string;
};

export type ServicesContent = {
  badge: string;
  heading: string;
  lede: string;
  cards: ServiceCard[];
};

@Injectable({ providedIn: 'root' })
export class ServicesSectionService {
  readonly content: ServicesContent = {
    badge: 'Four services. One cohesive journey.',
    heading: 'Built for pet-loving teams with seamless handoffs.',
    lede:
      'Each service team moves fast while the platform keeps brand, navigation, and experience consistent for every pet parent.',
    cards: [
      {
        id: 'grooming',
        title: 'Grooming',
        description: 'Spa-level coat care, styling, and seasonal refresh programs tailored to each pet.',
        accent: 'grooming',
        url: 'https://grooming.rufflesandshinegrooming.co.uk/'
      },
      {
        id: 'daycare',
        title: 'Day Care',
        description: 'Safe, supervised play with behavior-aware groups and instant updates for pet parents.',
        accent: 'daycare',
        url: 'https://daycare.rufflesandshinegrooming.co.uk'
      },
      {
        id: 'clinic',
        title: 'Clinic',
        description: 'Vet-first triage, tele-consults, and follow-up workflows ready for distributed teams.',
        accent: 'clinic',
        url: 'https://clinic.rufflesandshinegrooming.co.uk'
      },
      {
        id: 'ecommerce',
        title: 'E-Commerce',
        description: 'Curated essentials, nutrition plans, and accessories that integrate with in-clinic records.',
        accent: 'ecommerce',
        url: 'https://shop.rufflesandshinegrooming.co.uk'
      }
    ]
  };
}
